import { Component, OnInit } from '@angular/core';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

import {
    isSameMonth,
    isSameDay,
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    startOfDay,
    endOfDay,
    format
} from 'date-fns';
import { CalendarEvent } from 'angular-calendar';
import { BankBook } from '../../class/bank-book';
import { ActivatedRoute } from '@angular/router';
import { BankBookService } from '../../service/bank-book/bank-book.service';
import { BankService } from '../../service/bank/bank.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Bank } from '../../class/bank';
import { Company } from '../../class/company';
import { CompanyService } from '../../service/company/company.service';
import { INITIAL_OPTIONS } from '@ngrx/store-devtools/src/config';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-bank-books',
  templateUrl: './bank-books.component.html',
  styleUrls: ['./bank-books.component.scss']
})
export class BankBooksComponent implements OnInit {
    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    edit: BankBook;

    public form: FormGroup;
    public form3: FormGroup;
    public form4: FormGroup;
    public title: AbstractControl;
    public type: AbstractControl;
    public initial: AbstractControl;
    public ingress: AbstractControl;
    public egress: AbstractControl;
    public proyection: AbstractControl;
    public date: AbstractControl;
    public bank_id: AbstractControl;
    public company_id: AbstractControl;
    public activated: AbstractControl;

    public bank_id_filter: AbstractControl;
    public company_id_filter: AbstractControl;
    public type_id_filter: AbstractControl;

    public date_resume_filter: AbstractControl;

    public date12: Date;

    public viewType: string;

    public visibleSidebar2: boolean;

    public eventID: Number = 0;
    public modNew = false;
    public modView = false;
    public openEvent = false;
    public header: any;
    public bankBookList: BankBook[];
    public bankBookResumeList: {id: number, bank: Bank, initial: number, ingress: number, egress: number, proyection: number, need: number}[];
    public bankBookCalendar: BankBook[];
    public eventType: string;
    public filters: {key: string, value: string}[];
    public queryEvent: string;
    public query: string;

    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public es: any;

    public totalRecordsResume: number;
    public page_resume: number;
    public per_page_resume: number;
    public sort_resume: string;

    public minDate: Date;

    public optionsSelectionTypeBankBook: any[];

    public calendarStart: string;
    public calendarEnd: string;

    public types: SelectItem[];

    public totalResumeNeed: number;

    constructor(
        fb: FormBuilder,
        public bankService: BankService,
        public bankBookService: BankBookService,
        public companyService: CompanyService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        private route: ActivatedRoute) {
            this.types = [
                {label: 'Todo', value: 'all'},
                {label: 'Saldo Inicial', value: 'initial'},
                {label: 'Ingreso', value: 'ingress'},
                {label: 'Egreso', value: 'egress'},
                {label: 'Proyección', value: 'proyection'}
            ];

            this.optionsSelectionTypeBankBook = [];
            this.optionsSelectionTypeBankBook.push({label: 'initial', value: 'initial'});
            this.optionsSelectionTypeBankBook.push({label: 'ingress', value: 'ingress'});
            this.optionsSelectionTypeBankBook.push({label: 'egress', value: 'egress'});
            this.optionsSelectionTypeBankBook.push({label: 'proyection', value: 'proyection'});

            this.form = fb.group({
                'title': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
                'type': [''],
                'initial': [''],
                'ingress': [''],
                'egress': [''],
                'proyection': [''],
                'date': [''],
                'bank_id': [''],
                'company_id': [''],
                'activated': [''],
            });
            this.title = this.form.controls['title'];
            this.type = this.form.controls['type'];
            this.initial = this.form.controls['initial'];
            this.ingress = this.form.controls['ingress'];
            this.egress = this.form.controls['egress'];
            this.proyection = this.form.controls['proyection'];
            this.date = this.form.controls['date'];
            this.bank_id = this.form.controls['bank_id'];
            this.company_id = this.form.controls['company_id'];
            this.activated = this.form.controls['activated'];

            this.form3 = fb.group({
                'bank_id_filter': [''],
                'company_id_filter': [''],
                'type_id_filter': ['']
            });
            this.bank_id_filter = this.form3.controls['bank_id_filter'];
            this.company_id_filter = this.form3.controls['company_id_filter'];
            this.type_id_filter = this.form3.controls['type_id_filter'];

            this.form4 = fb.group({
                'date_resume_filter': [''],
            });
            this.date_resume_filter = this.form4.controls['date_resume_filter'];

            this.minDate = new Date();
            this.date.setValue(this.minDate);
    }

    ngOnInit() {
        const dateStart = new Date();
        const dateEnd = new Date();
        dateStart.setHours(23, 59, 59, 59);
        dateEnd.setHours(0, 0, 0, 0);
        this.es = calendarES();

        this.bankBookList = [];
        this.bankBookResumeList = [];
        this.bankBookCalendar = [];
        this.header = {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,listDay'
        };

        this.query = undefined;

        this.getBankBook(this.query, this.filters);

        this.page = 1;
        this.per_page = 10;

        this.page_resume = 1;
        this.per_page_resume = 10;

        this.viewType = 'resume';
    }

    public onChangeType($event) {
        if ($event === 'other') {
            this.title.setValue('Otro');
        } else {
            this.translate.get($event).subscribe((res: string) => {
                this.title.setValue(res);
            });
        }
    }

    public loadBankBookLazy(bankBook: LazyLoadEvent) {
        this.page = (bankBook.first / this.per_page) + 1;
        if (bankBook.sortOrder === -1) {
            this.sort =  '-' + bankBook.sortField;
        } else {
            this.sort =  bankBook.sortField;
        }
        this.getBankBook(bankBook.globalFilter);
    }

    public newBankBook(values: any) {
        let initial = 0;
        let ingress = 0;
        let egress = 0;
        let proyection = 0;

        if (values.initial) {
            initial = values.initial;
        }

        if (values.ingress) {
            ingress = values.ingress;
        }

        if (values.egress) {
            if (values.egress <= 0) {
                egress = values.egress;
            } else {
                egress = values.egress * -1;
            }
        }

        if (values.proyection) {
            if (values.proyection <= 0) {
                proyection = values.proyection;
            } else {
                proyection = values.proyection * -1;
            }
        }

        const param = {
            'title': values.title,
            'type': values.type,
            'initial': initial,
            'ingress': ingress,
            'egress': egress,
            'proyection': proyection,
            'date': values.date,
            'bank_id': values.bank_id,
            'company_id': values.company_id.id,
            'activated': true,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.bankBookService.updateBankBook(this.edit.id, param)
                :
                this.bankBookService.newBankBook(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.getBankBook();
                    this.getBankBookCalendar();
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                        this.form.reset();
                        this.bank_id.reset();
                        this.company_id.reset();
                    });
                    this.visibleSidebar2 = false;
                },
                error => {
                    this.getBankBook();
                    this.msgs = [];
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    getBankBook(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.bankBookService.getBankBook(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.bankBookList = response.json().data;
                this.bankBookResumeList = [];
                this.totalResumeNeed = 0;
                this.bankBookList.forEach(element => {
                    const pos = this.findElement(this.bankBookResumeList, element.bank_id);
                    if (pos >= 0) {
                        this.bankBookResumeList[pos].egress = this.bankBookResumeList[pos].egress + Number(element.egress);
                        this.bankBookResumeList[pos].ingress = this.bankBookResumeList[pos].ingress + Number(element.ingress);
                        this.bankBookResumeList[pos].initial = this.bankBookResumeList[pos].initial + Number(element.initial);
                        this.bankBookResumeList[pos].proyection = this.bankBookResumeList[pos].proyection + Number(element.proyection);
                        this.bankBookResumeList[pos].need = Number(this.bankBookResumeList[pos].initial) + Number(this.bankBookResumeList[pos].ingress) + Number(this.bankBookResumeList[pos].egress) + Number(this.bankBookResumeList[pos].proyection);
                    } else {
                        this.bankBookResumeList.push({
                            id: element.bank_id,
                            bank: element.bank,
                            initial: Number(element.initial),
                            ingress: Number(element.ingress),
                            egress: Number(element.egress),
                            proyection: Number(element.proyection),
                            need: Number(element.initial) + Number(element.ingress) + Number(element.egress) + Number(element.proyection)});
                    }
                    this.totalResumeNeed += Number(element.initial) + Number(element.ingress) + Number(element.egress) + Number(element.proyection);
                });
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    getBankBookCalendar(event?: any, query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (event) {
            if (filtersReceived) {
                filtersReceived.forEach(element => {
                    if (element.value) {
                        filters.push({'key': element.key, 'value': element.value});
                    }
                });
            }
            this.calendarStart = new Date(event.view.start._i).toISOString();
            this.calendarEnd = new Date(event.view.end._i).toISOString();
            filters.push({'key': 'date-min', 'value': this.calendarStart});
            filters.push({'key': 'date-max', 'value': this.calendarEnd});
        } else if (this.calendarStart && this.calendarEnd) {
            if (filtersReceived) {
                filtersReceived.forEach(element => {
                    if (element.value) {
                        filters.push({'key': element.key, 'value': element.value});
                    }
                });
            }
            filters.push({'key': 'date-min', 'value': this.calendarStart});
            filters.push({'key': 'date-max', 'value': this.calendarEnd});
        }

        this.bankBookService.getBankBook(1, 1000, this.sort, query, filters).toPromise().then(
            response => {
                this.bankBookCalendar = response.json().data;
                this.reloadListCalendar();
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public savedBankBook(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.edit = null;
        this.modNew = false;
        this.getBankBook();
    }

    public cancelBankBook () {
        this.edit = null;
        this.visibleSidebar2 = false;
        this.getBankBook();
    }

    public deleteDialog(bankBook: BankBook) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(bankBook);
            }
        });
    }

    public delete(bankBook: BankBook) {
        this.bankBookService.deleteBankBook(bankBook.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getBankBook();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeBankBook(bankBook: BankBook) {
        this.putBankBook(bankBook);
    }

    public putBankBook(values: BankBook) {
        const param = {
            'title': values.title,
            'initial': values.initial,
            'ingress': values.ingress,
            'egress': values.egress,
            'proyection': values.proyection,
            'date': values.date,
            'bank_id': values.bank_id,
            'company_id': values.company_id,
            'activated': values.activated
        };
        if (values) {
            const promise = this.bankBookService.updateBankBook(values.id, param);
            this.promiseForm = promise.toPromise().then(
                reBankBooke => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public reloadListCalendar() {
        this.bankBookCalendar.forEach(element => {
            if (element.type === 'initial') {
                element.textColor = '#FFFFFF';
                element.color = '#ffc107';
            }

            if (element.type === 'ingress') {
                element.textColor = '#FFFFFF';
                element.color = '#ffc107';
            }

            if (element.type === 'egress') {
                element.textColor = '#FFFFFF';
                element.color = '#28a745';
            }

            if (element.type === 'proyection') {
                element.textColor = '#FFFFFF';
                element.color = '#17a2b8';
            }

            this.translate.get(element.type).subscribe((res: string) => {
                element.title = '#' + element.id + ' - ' + res + ' - ' + element.bank.name + ' - ' + element.company.name + ' - ';
            });
        });
    }

    public showNewBankBook() {
        this.edit = null;
        this.form.reset();
        this.visibleSidebar2 = true;
    }

    public showBankBook(event) {
        this.visibleSidebar2 = true;
        this.edit = event;
        this.title.setValue(this.edit.title);
        this.type.setValue(this.edit.type);
        this.initial.setValue(this.edit.initial);
        this.ingress.setValue(this.edit.ingress);
        this.egress.setValue(this.edit.egress);
        this.proyection.setValue(this.edit.proyection);
        this.date.setValue(this.edit.date);
        this.bank_id.setValue(this.edit.bank_id);
        this.company_id.setValue(this.edit.company);
        this.activated.setValue(this.edit.activated);
    }

    public resumeView() {
        this.viewType = 'resume';
    }

    public listView() {
        this.viewType = 'list';
    }

    public calendarView() {
        this.viewType = 'calendar';
    }

    handleBankBookClick(e) {
        this.showBankBook(e.calEvent);
    }

    public findElement (list, search) {
        let find = -1;
        let itera = 0;
        list.forEach(element => {
            if (element.id === search) {
                find = itera;
            }
            itera++;
        });
        return find;
    }

    public filter (values) {
        const filters = [];
        if (values.bank_id_filter) {
            filters.push({'key': 'bank_id-lk', 'value': values.bank_id_filter.id});
        }
        if (values.company_id_filter) {
            filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});
        }
        if (values.type_id_filter !== 'all') {
            filters.push({'key': 'type-lk', 'value': values.type_id_filter});
        }
        this.getBankBook(undefined, filters);
        this.getBankBookCalendar(undefined, undefined, filters);
    }

    public filterResume (values) {
        const filters = [];
        if (values.date_resume_filter) {
            filters.push({'key': 'date-min', 'value': values.date_resume_filter.id});
            filters.push({'key': 'date-max', 'value': values.date_resume_filter.id});
        }
        this.getBankBook(undefined, filters);
        this.getBankBookCalendar(undefined, undefined, filters);
    }

    public cleanFormFilter() {
        this.form3.reset();
        this.company_id_filter.setValue('');
        this.bank_id_filter.setValue('');
        this.type_id_filter.setValue('');
        this.getBankBook();
        this.getBankBookCalendar();
    }

    printToCart(printSectionId: string) {
        let popup;
        const innerContents = document.getElementById(printSectionId).innerHTML;
        popup = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popup.document.open();
        popup.document.write('<html>' +
                            '<head>' +
                            '<style>' +
                            '.fc-button-group { display: none;}' +
                            '.fc-left { display: none;}' +
                            '.fc-scroller { overflow-x: unset !important; overflow-y: unset !important;}' +
                            '</style>' +
                            '</head>' +
                            '<body onload="window.print()">' +
                            innerContents +
                            '</body>' +
                            '</html>');
        popup.document.close();
    }

    public checkBank (values) {
        let check = false;
        if (values) {
            if (values.bank_id) {
                check = true;
            }
        }
        return check;
    }

    public checkCompany (values) {
        let check = false;
        if (values) {
            if (values.company_id) {
                if (values.company_id.id) {
                    check = true;
                } else if (values.company_id.id >= 0) {
                    check = true;
                }
            }
        }
        return check;
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/bank-books/bank-books.component.ts